"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNotificationStatus = exports.createResolvedStatus = exports.createRejectedStatus = exports.loadingStatus = exports.isStatus = void 0;
const loading_states_const_1 = require("../../constants/loading-states.const");
const symbol = Symbol('AggregationStatus');
function isStatus(status) {
    return Boolean((status || {})[symbol]);
}
exports.isStatus = isStatus;
exports.loadingStatus = Object.freeze({
    status: loading_states_const_1.LOADING_STATES.LOADING,
    [symbol]: true
});
function createRejectedStatus(error) {
    return {
        status: loading_states_const_1.LOADING_STATES.REJECTED,
        error,
        [symbol]: true
    };
}
exports.createRejectedStatus = createRejectedStatus;
function createResolvedStatus(value) {
    return {
        status: loading_states_const_1.LOADING_STATES.RESOLVED,
        value,
        [symbol]: true
    };
}
exports.createResolvedStatus = createResolvedStatus;
function createNotificationStatus(notification) {
    return {
        status: loading_states_const_1.LOADING_STATES.NOTIFICATION,
        notification,
        [symbol]: true
    };
}
exports.createNotificationStatus = createNotificationStatus;
